<p *ngIf="langue.l == 'fr'">
    Les magies sont de deux types : tangible et intangible.<br/>
    "Faire de la magie" est appelé "invoquer" et est séparé en plusieurs étapes :<br/>
    1- création -ou- prise de contrôle<br/>
    2- manipulation<br/>
    3- dissipation -ou- relâchement de contrôle.<br/>
    <br/>
    Une invocation peut donc par exemple se dérouler comme ceci : création, manipulation, relâchement de contrôle ;<br/>
    ou bien : prise de contrôle puis dissipation.<br/>
    Il faut exactement une étape 1 et une étape 3, et un nombre quelconque d'étape 2. L'étape 2 est techniquement optionelle.<br/>
    La création et la dissipation sont légèrement plus difficiles et plus coûteuses pour les magies tangibles.<br/>
    <br/>
    Garder le contrôle d'un élément demande une concentration de niveau dépendant de la taille de l'élément et de sa tangibilité.<br/>
    (cf <a routerLink="/system/states" routerLinkActive="activebutton">état concentré</a>).<br/>
</p>
<p *ngIf="langue.l == 'en'">
    Magics are of two types : tangible and intangible.<br/>
    "To do magic" is called "invoking" and is separated in several steps :
     1- creation -or- taking control, 2- manipulation, 3- dissipation -or- releasing control.<br/>
    An invocation can for example go like this : creation, manipulation, releasing control ; or : taking control then dissipation.<br/>
    The invocation requires exactly one step 1 and one step 3, and any number of step 2. Step 2 is technically optional.<br/>
    Creation and dissipation are slightly more difficult for tangible magics.<br/>
    <br/>
    Keeping control of an element requires a concentration of level depending on the size and the tangibility of that element.<br/>
</p>


<div class="div-table" *ngIf="langue.l == 'fr'">
    <table>
        <tr>
            <th>Étape</th>
            <th>Action</th>
            <th>Coût PA tangible</th>
            <th>Coût PA intangible</th>
        </tr>
        <tr>
            <td>1</td>
            <td>création</td>
            <td>3</td>
            <td>1</td>
        </tr>
        <tr>
            <td>1</td>
            <td>prise de contrôle</td>
            <td>1*</td>
            <td>1*</td>
        </tr>
        <tr>
            <td>2</td>
            <td>manipulation</td>
            <td>3</td>
            <td>3</td>
        </tr>
        <tr>
            <td>3</td>
            <td>relâchement de contrôle</td>
            <td>0</td>
            <td>0</td>
        </tr>
        <tr>
            <td>3</td>
            <td>dissipation</td>
            <td>2</td>
            <td>0</td>
        </tr>
    </table>
</div>
<div class="div-table" *ngIf="langue.l == 'en'">
    <table>
        <tr>
            <th>Step</th>
            <th>Action</th>
            <th>Cost AP tangible</th>
            <th>Cost AP intangible</th>
        </tr>
        <tr>
            <td>1</td>
            <td>creation</td>
            <td>3</td>
            <td>1</td>
        </tr>
        <tr>
            <td>1</td>
            <td>taking control</td>
            <td>1</td>
            <td>1</td>
        </tr>
        <tr>
            <td>2</td>
            <td>manipulation</td>
            <td>3</td>
            <td>3</td>
        </tr>
        <tr>
            <td>3</td>
            <td>releasing control</td>
            <td>0</td>
            <td>0</td>
        </tr>
        <tr>
            <td>3</td>
            <td>dissipation</td>
            <td>2</td>
            <td>0</td>
        </tr>
    </table>
</div>
<p *ngIf="langue.l == 'fr'">
    * = La prise de contrôle coûte 1 PA si non contestée,
    et 3 PA si l'élément est déjà sous le contrôle d'une autre source.
    Il faut ensuite faire des jets de sensitivité opposés pour gagner le contrôle,
    cf <a routerLink="/system/magic/creation" routerLinkActive="activebutton">prise de contrôle</a>.
</p>
<p *ngIf="langue.l == 'en'">
    * = Taking control costs 1 AP if it is not contested,
    and 3 AP is the element is already under the control of someone else.
    In that case, the two opposing forces need to roll sensitivity until one of them wins,
    see <a routerLink="/system/magic/creation" routerLinkActive="activebutton">Taking control</a>.
</p>

<p *ngIf="langue.l == 'fr'">
    Pour créer, un mage se concentre sur le concept de l'élément qu'il veut faire apparaître et décide d'une taille que va prendre l'élément créé
    (cf <a routerLink="/system/magic/creation" routerLinkActive="activebutton">création</a>).
    Quand l'élément prend forme, le mage dépense l'énergie nécessaire et si il n'a pas assez, l'élément ne se manifeste pas.<br/>
    Le mage créant est appelé la source de l'élément, et une fois créé l'élément est sous le contrôle de sa source.<br/>
    Afin de manipuler un élément, un mage doit <b>obligatoirement</b> avoir le contrôle sur cet élément. Si il n'a pas le contrôle dessus, il ne peut rien en faire. <br>
    Pour effectuer une manipulation, le joueur lance ses dés de magies
    (cf <a routerLink="/system/magic/manipulation" routerLinkActive="activebutton">manipulation</a>)
    et décide de l'effet que son sort va avoir selon les 4 caractéristiques de sorts.<br/>
    <br/>
    Si le mage ne veut qu'un effet visuel ou mineur,
    il peut considérer qu'il obtient des 1 à tous ses dés et ne les lance pas.
    Il ajoute ensuite ses bonus et peut lancer le sort. Le sort est appelé un sort mineur.<br/>
    Si le mage veut un "vrai" sort utile, il commance par lancer ses dés.
    Il les distribue sur les 4 caractéristiques
    (cf <a routerLink="/system/magic/manipulation" routerLinkActive="activebutton">manipulation</a>),
    compte le total des dés pour déterminer la puissance et donc le niveau du sort,
    puis ajoute ses bonus et peut lancer le sort en dépensant les points d'énergie selon le niveau du sort.<br/>
    <br/>
    À tout moment de la manipulation, le mage peut décider d'arrêter de lancer le sort.
    Il pert ses points d'action déjà dépensés mais n'a pas à en dépenser plus. Ainsi, hors combat la magie est plus contrôlable.<br/>
    <br/>
    Après la manipulation, le mage doit décider de soit garder le contrôle de l'élément, soit le relâcher, soit dissiper l'élément.
    Dissiper l'élément correspond à le faire disparaître, et est l'opposé de la création.
    Si le mage décide de garder le contrôle, alors il doit payer le prix de concentration pour le contrôle de l'élément
    (cf <a routerLink="/system/magic/concentration" routerLinkActive="activebutton">concentration : Contrôle sur un élément</a>).
    Si le mage décide de relâcher le contrôle, alors il faudra le reprendre à la prochaine manipulation.
    <br/>
    <br/>
    Un mage peut essayer de prendre le contrôle de l'élément d'un autre mage
    (cf <a routerLink="/system/magic/creation" routerLinkActive="activebutton">création : prise de contrôle</a>).
</p>
<p *ngIf="langue.l == 'en'">
    To create, a mage rolls <b>1d12 + sensitivity</b>
    and gets the maximum ballpark for the size of the created element
    (see <a routerLink="/system/magic/creation" routerLinkActive="activebutton">creation</a>).
    The mage decides how much of the element is actually created
    (which will decide the maximum size of the manipulation to come)
    and spends the corresponding energy.
    The created element is under the mage's control.<br/>
    To manipulate, a mage needs some element under their control
    (either taken, or created) and starts the manipulation.<br/>
    <br/>
    If the mage only wants a visual or minor effect,
    they can consider that they rolled 1 on all their dice and doesn't need to really roll them.
    They can then add their bonuses and cast the spell. The spell is called a minor spell.<br/>
    If the mage wants a real useful spell, they can spend 1 energy point to roll their dice.
    They distribute them on the 4 caracteristics
    (see <a routerLink="/system/magic/manipulation" routerLinkActive="activebutton">manipulation</a>),
    counts the total of all dice to determine the power of and level of the spell,
    then they can add their bonuses and cast the spell by spending the appropriate extra energy points
    depending on the spell level.<br/>
    <br/>
    At any moment of the manipulation, the mage can decide to stop.
    They lose any energy or action points already spent, but do not have to spend any more.<br/>
    <br/>
    After the manipulation, the mage can dissipate the element, or just release it.<br/>
    <br/>
    A mage can try to take control over the element under the control of another mage.
    (see <a routerLink="/system/magic/creation" routerLinkActive="activebutton">creation</a>)
</p>
